import { Modal } from "antd"
import { useState, useEffect } from "react"
import { useDispatch } from "react-redux"

import "./FormDocuSignRequest.css"
import { useGetClientDocusignFormsMutation } from "./formApiSlice"
import { showSpinner, hideSpinner } from "../../components/componentSlice"
import FormDocuSign from "./FormDocuSign"
import FormDocuSignPreview from "./FormDocuSignPreview"
import { EyeOutlined } from "@ant-design/icons"

const FormDocuSignIndividualRequest = ({ crmId, clientId, openModal, handleModalOpen }) => {

    const [documents, setDocuments] = useState([])
    const [invalidReasons, setInvalidReasons] = useState([])
    const [errorMessage, setErrorMessage] = useState(null)
    const [isDocusignPreviewModalOpen, setDocusignPreviewModalOpen] = useState(false)

    const [getClientDocusignForms, { isLoading: isgetClientDocusignFormsLoading }] = useGetClientDocusignFormsMutation()
    const dispatch = useDispatch()

    useEffect(() => {
        if (isgetClientDocusignFormsLoading) {
            dispatch(showSpinner())
        } else {
            dispatch(hideSpinner())
        }
    }, [isgetClientDocusignFormsLoading])

    useEffect(() => {
        const getClientDocuments = async (id) => {
            try {
                let response = await getClientDocusignForms(id).unwrap()
                if(response) {
                    setDocuments(response.documents)
                    setInvalidReasons(response.invalidReasons)
                }
                
            } catch(err) {
                setErrorMessage(err.data?.detail)
            }
        }

        if(clientId) {
            getClientDocuments(clientId)
        }
    }, [clientId])

    return (
        <Modal className="form-docusign-request-modal" width="100%" open={openModal} onCancel={() => handleModalOpen(false)} footer={[]}>
            {errorMessage && 
                <div className="errorMessage">
                    <p>{errorMessage}</p>
                </div>
            }
            <div className="docusign-individual-container">
                {documents?.length > 0 && 
                    <>
                        <FormDocuSign isBulk={false} clientId={clientId} invalidReasons={invalidReasons} />
                        <div className="preview-button-container">
                            <button className="preview-button" onClick={() => setDocusignPreviewModalOpen(true)}>
                                <span>Preview client documents</span>
                                <EyeOutlined />
                            </button>
                        </div>
                        
                    </>
                }
            </div>

            {isDocusignPreviewModalOpen &&
                <FormDocuSignPreview
                    documents={documents}
                    openModal={isDocusignPreviewModalOpen}
                    handleModalOpen={setDocusignPreviewModalOpen}
                />
            }
        </Modal>
    )
}

export default FormDocuSignIndividualRequest